
import { defineComponent } from '@nuxtjs/composition-api'
import { ConfettiLoader } from '~/components/ConfettiLoader.vue'

interface Props {
  loading?: boolean
  disabled?: boolean
}

export const ConfettiButton = defineComponent<Props>({
  props: {
    loading: Boolean,
    disabled: Boolean,
  },
  components: {
    ConfettiLoader,
  },
})

export default ConfettiButton
